<template>
  <figure class="image is-32x32">
    <img
      :src="user.profile_picture.sm"
      class="is-circle"
      style="width: 32px; height: 32px;"
    />
  </figure>
</template>

<script>
export default {
  props: ["user"]
};
</script>
